var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaxes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    width: 406,
    height: 306,
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3592.1895,
    y1: 4016.7405,
    x2: 1145.9692,
    y2: 978.6884
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2919.219,2818.643c-56.189,59.153-109.354,97.3-151.359,127.439 c-493.758,354.277-1078.005,251.007-1202.175,225.787c-183.359-37.241-537.787-109.227-794.032-410.566 c-387.678-455.901-327.311-1174.161-26.602-1648.293c55.004-86.727,345.554-568.082,936.093-645.276 c357.388-46.717,773.988,47.506,1075.679,300.262C3390.099,1298.554,3345.016,2370.376,2919.219,2818.643z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2787.801,1245.807c0.352,4.986-3.114,9.535-8.144,10.423c-11,1.944-22.249,3.438-33.432,4.442 c-5.441,0.489-10.248-3.525-10.736-8.964c-0.005-0.066-0.009-0.129-0.014-0.193c-0.378-5.36,3.604-10.06,8.979-10.542 c10.625-0.953,21.31-2.374,31.76-4.219c5.378-0.951,10.51,2.639,11.46,8.019 C2787.737,1245.118,2787.777,1245.463,2787.801,1245.807z M2701.818,1251.238c0.027,0.385,0.032,0.778,0.013,1.174 c-0.258,5.455-4.89,9.671-10.345,9.413c-11.206-0.531-22.5-1.547-33.568-3.019c-5.415-0.72-9.207-5.67-8.502-11.107 c0.721-5.414,5.697-9.218,11.107-8.498c10.52,1.399,21.249,2.363,31.9,2.865 C2697.481,1242.306,2701.47,1246.308,2701.818,1251.238z M2616.778,1237.603c0.077,1.098-0.029,2.229-0.341,3.35 c-1.468,5.26-6.92,8.339-12.182,6.873c-10.784-3.003-21.574-6.515-32.066-10.436c-5.115-1.916-7.706-7.614-5.802-12.726 c1.912-5.115,7.611-7.713,12.726-5.801c9.964,3.725,20.206,7.058,30.449,9.911 C2613.703,1229.926,2616.491,1233.549,2616.778,1237.603z M2536.905,1205.287c0.128,1.815-0.243,3.687-1.175,5.404 c-2.604,4.8-8.609,6.579-13.409,3.975c-9.846-5.346-19.579-11.18-28.929-17.342c-4.553-3.007-5.815-9.137-2.814-13.7 c3.005-4.559,9.139-5.819,13.7-2.814c8.879,5.852,18.123,11.395,27.481,16.472 C2534.839,1198.956,2536.675,1202.029,2536.905,1205.287z M2466.245,1155.972c0.18,2.546-0.62,5.158-2.437,7.224 c-3.606,4.104-9.855,4.506-13.955,0.9c-8.394-7.377-16.592-15.219-24.358-23.307c-3.787-3.936-3.663-10.197,0.279-13.982 c3.939-3.782,10.198-3.657,13.985,0.281c7.382,7.689,15.173,15.141,23.15,22.153 C2464.943,1151.03,2466.068,1153.468,2466.245,1155.972z M2408.258,1092.26c0.233,3.297-1.189,6.635-4.063,8.715 c-4.425,3.203-10.606,2.215-13.811-2.208c-6.565-9.065-12.825-18.527-18.599-28.121c-2.817-4.682-1.306-10.757,3.375-13.574 c4.676-2.816,10.755-1.305,13.572,3.373c5.488,9.116,11.432,18.104,17.671,26.718 C2407.528,1088.716,2408.132,1090.481,2408.258,1092.26z M2359.249,732.436c0.096,1.366-0.091,2.771-0.599,4.138 c-3.704,9.958-7.022,20.213-9.861,30.478c-1.456,5.263-6.904,8.351-12.165,6.895c-5.265-1.454-8.353-6.902-6.896-12.167 c2.989-10.811,6.483-21.612,10.382-32.099c1.904-5.12,7.599-7.726,12.717-5.822 C2356.581,725.253,2358.984,728.687,2359.249,732.436z M2365.86,1017.329c0.289,4.092-2.008,8.098-5.993,9.795 c-5.027,2.14-10.834-0.2-12.974-5.224c-4.386-10.299-8.377-20.915-11.863-31.553c-1.676-5.197,1.125-10.777,6.318-12.478 c5.189-1.7,10.776,1.129,12.479,6.32c3.308,10.103,7.099,20.183,11.263,29.963 C2365.531,1015.191,2365.785,1016.263,2365.86,1017.329z M2338.517,816.053c0.046,0.651,0.031,1.316-0.057,1.989 c-1.382,10.542-2.323,21.283-2.807,31.924c-0.25,5.457-4.874,9.679-10.328,9.431c-5.455-0.25-9.704-4.868-9.431-10.328 c0.51-11.197,1.502-22.499,2.953-33.592c0.71-5.416,5.676-9.232,11.09-8.523 C2334.677,807.574,2338.192,811.46,2338.517,816.053z M2341.263,934.806c0.352,4.978-3.104,9.523-8.125,10.42 c-5.377,0.961-10.513-2.619-11.478-7.996c-1.966-11.008-3.484-22.25-4.504-33.412c-0.009-0.069-0.014-0.14-0.019-0.21 c-0.378-5.352,3.593-10.047,8.961-10.541c5.441-0.498,10.254,3.505,10.751,8.945c0.973,10.602,2.416,21.28,4.286,31.739 C2341.194,934.104,2341.239,934.457,2341.263,934.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2389.242,669.805c0.137,1.942-0.294,3.946-1.368,5.747c-2.611,4.38-5.17,8.889-7.616,13.399 c-2.6,4.801-8.604,6.587-13.405,3.984c-4.803-2.6-6.594-8.606-3.982-13.407c2.569-4.745,5.263-9.486,8.008-14.096 c2.794-4.691,8.866-6.232,13.555-3.438C2387.329,663.717,2389.022,666.684,2389.242,669.805z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2632.428,491.577c0.336,4.761-2.821,9.195-7.617,10.316c-4.964,1.158-9.989,2.44-14.931,3.811 c-5.264,1.46-10.714-1.623-12.174-6.886c-1.465-5.285,1.625-10.714,6.886-12.174c5.203-1.442,10.495-2.794,15.722-4.014 c5.319-1.241,10.636,2.064,11.879,7.383C2632.315,490.536,2632.391,491.059,2632.428,491.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M3104.461,839.072c0.321,4.539,0.565,9.101,0.734,13.684c0.199,5.458-4.062,10.046-9.52,10.247 c-5.458,0.201-10.067-4.085-10.249-9.518c-0.39-10.577-1.208-21.115-2.448-31.439c-0.643-5.429,3.216-10.346,8.637-10.998 c5.426-0.652,10.351,3.217,11.001,8.64C3103.384,826.074,3104.003,832.596,3104.461,839.072z M3103.547,904.942 c0.039,0.551,0.032,1.115-0.025,1.684c-1.087,10.98-2.654,22.037-4.654,32.86c-0.992,5.369-6.151,8.919-11.519,7.927 c-5.372-0.994-8.935-6.162-7.927-11.523c1.9-10.28,3.385-20.783,4.422-31.218c0.538-5.434,5.381-9.403,10.813-8.865 C3099.524,896.292,3103.213,900.223,3103.547,904.942z M3092.842,768.573c0.328,4.651-2.682,9.024-7.354,10.251 c-5.285,1.386-10.69-1.774-12.078-7.057c-2.649-10.106-5.77-20.236-9.279-30.111c-1.82-5.15,0.864-10.802,6.01-12.629 c5.149-1.827,10.803,0.864,12.631,6.011c3.693,10.399,6.979,21.068,9.771,31.711 C3092.701,767.357,3092.799,767.968,3092.842,768.573z M3085.94,987.895c0.088,1.252-0.065,2.541-0.483,3.806 c-3.471,10.463-7.431,20.904-11.77,31.032c-2.151,5.02-7.963,7.345-12.982,5.194c-5.023-2.151-7.351-7.96-5.196-12.984 c4.119-9.616,7.88-19.53,11.175-29.468c1.717-5.185,7.316-7.992,12.499-6.273 C3083.102,980.501,3085.666,984.016,3085.94,987.895z M3062.396,689.502c0.269,3.815-1.701,7.606-5.314,9.48 c-4.849,2.515-10.818,0.623-13.333-4.226c-4.806-9.27-10.079-18.465-15.67-27.332c-2.913-4.62-1.532-10.727,3.092-13.64 c4.62-2.911,10.724-1.528,13.637,3.091c5.887,9.334,11.438,19.014,16.5,28.776 C3061.948,686.885,3062.304,688.196,3062.396,689.502z M3015.337,619.025c0.215,3.05-0.983,6.157-3.501,8.275 c-4.182,3.513-10.42,2.972-13.934-1.21c-6.739-8.019-13.895-15.848-21.265-23.268c-3.855-3.869-3.837-10.129,0.043-13.985 c3.876-3.85,10.135-3.829,13.987,0.045c7.758,7.809,15.287,16.047,22.377,24.486 C3014.439,615.028,3015.195,617.013,3015.337,619.025z M2954.032,560.484c0.164,2.32-0.485,4.704-2.009,6.698 c-3.315,4.339-9.522,5.169-13.861,1.852c-8.33-6.367-17.016-12.451-25.825-18.084c-4.599-2.942-5.949-9.052-3.002-13.659 c2.944-4.6,9.057-5.945,13.66-3.002c9.268,5.929,18.414,12.331,27.177,19.03 C2952.519,555.113,2953.839,557.752,2954.032,560.484z M2881.425,516.709c0.114,1.607-0.165,3.263-0.887,4.83 c-2.287,4.96-8.16,7.125-13.119,4.837c-9.515-4.389-19.323-8.42-29.155-11.982c-5.135-1.86-7.79-7.538-5.932-12.665 c1.86-5.137,7.532-7.791,12.667-5.931c10.357,3.751,20.687,7.996,30.702,12.616 C2879.095,509.983,2881.179,513.228,2881.425,516.709z M2800.948,489.931c0.064,0.904,0.002,1.832-0.196,2.762 c-1.137,5.341-6.391,8.75-11.731,7.611c-10.222-2.177-20.672-3.947-31.065-5.258c-5.42-0.684-9.252-5.648-8.572-11.049 c0.683-5.419,5.632-9.258,11.051-8.574c10.94,1.381,21.943,3.243,32.704,5.537 C2797.55,481.9,2800.645,485.647,2800.948,489.931z M2716.611,481.494c0.014,0.202,0.021,0.407,0.024,0.612 c0.052,5.46-4.333,9.931-9.793,9.982c-7.709,0.074-15.506,0.386-23.182,0.928c-2.778,0.196-5.55,0.425-8.309,0.68 c-5.44,0.502-10.258-3.499-10.758-8.937c-0.616-5.496,3.498-10.254,8.933-10.758c2.905-0.269,5.816-0.507,8.74-0.714 c8.073-0.57,16.279-0.898,24.387-0.975C2711.908,472.26,2716.246,476.32,2716.611,481.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M3050.37,1065.133c0.138,1.961-0.303,3.981-1.392,5.791c-2.762,4.587-5.674,9.201-8.655,13.716 c-3.009,4.559-9.143,5.816-13.7,2.807c-4.558-3.01-5.819-9.139-2.807-13.701c2.83-4.289,5.596-8.673,8.22-13.027 c2.814-4.677,8.892-6.187,13.572-3.369C3048.475,1059.079,3050.151,1062.032,3050.37,1065.133z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2935.01,1059.901c1.436-1.351,1.857-3.465,1.048-5.263l-23.087-51.3 c14.524-21.891,25.663-46.256,32.628-72.379l53.681-16.7c1.884-0.585,3.187-2.302,3.247-4.272l2.056-67.446 c0.059-1.972-1.138-3.763-2.98-4.463l-52.565-19.937c-5.362-26.499-14.995-51.497-28.16-74.232l26.167-49.799 c0.917-1.745,0.626-3.88-0.725-5.317l-46.238-49.145c-1.352-1.437-3.466-1.857-5.263-1.048l-51.299,23.086 c-21.891-14.524-46.257-25.662-72.38-32.627l-16.7-53.682c-0.585-1.883-2.301-3.186-4.272-3.247l-67.447-2.055 c-1.971-0.06-3.763,1.137-4.462,2.981l-19.938,52.565c-26.5,5.362-51.497,14.994-74.231,28.16l-49.8-26.168 c-1.744-0.916-3.88-0.625-5.316,0.726l-49.145,46.239c-1.437,1.351-1.857,3.465-1.048,5.263l23.087,51.299 c-14.525,21.891-25.663,46.256-32.628,72.38l-53.682,16.7c-1.882,0.586-3.187,2.301-3.247,4.272l-2.054,67.447 c-0.061,1.971,1.136,3.763,2.981,4.462l52.565,19.937c5.361,26.5,14.995,51.497,28.16,74.232l-26.167,49.799 c-0.918,1.745-0.626,3.882,0.725,5.317l46.239,49.145c1.351,1.436,3.464,1.857,5.263,1.048l51.299-23.086 c21.891,14.525,46.257,25.662,72.38,32.627l16.7,53.682c0.585,1.882,2.301,3.187,4.273,3.246l67.446,2.056 c1.971,0.06,3.763-1.136,4.463-2.98l19.937-52.565c26.499-5.362,51.496-14.995,74.231-28.16l49.799,26.167 c1.746,0.918,3.88,0.626,5.317-0.725L2935.01,1059.901z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2775.086,862.506c2.329,32.981-19.845,63.651-53.074,70.972 c-36.527,8.045-72.784-15.124-80.831-51.648c-3.902-17.695-0.672-35.847,9.082-51.111 c9.754-15.267,24.871-25.822,42.564-29.718c36.528-8.045,72.784,15.124,80.831,51.648 C2774.382,855.941,2774.855,859.237,2775.086,862.506z M2655.527,870.793c0.18,2.547,0.546,5.094,1.104,7.634 c6.168,28.003,33.972,45.767,61.973,39.6c28.004-6.169,45.781-33.965,39.601-61.975c-6.167-28.003-33.972-45.767-61.973-39.6 c-13.568,2.989-25.156,11.08-32.637,22.786C2657.519,848.752,2654.746,859.732,2655.527,870.793z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2872.71,854.223c0.4,5.664,0.518,11.382,0.343,17.135l0,0 c-0.054,1.811-0.139,3.621-0.252,5.43c-0.559,8.917-1.827,17.776-3.783,26.44c-0.027,0.118-0.053,0.236-0.079,0.354 c-0.077,0.335-0.154,0.669-0.235,1.004c-0.151,0.652-0.311,1.302-0.47,1.95c-0.422,1.706-1.892,2.877-3.556,2.997 c-0.405,0.029-0.821-0.006-1.235-0.108c-2.121-0.524-3.407-2.672-2.886-4.79c2.703-10.912,4.247-22.188,4.589-33.516 c1.724-56.269-26.187-106.685-69.586-136.245c-24.137-16.445-53.07-26.434-84.366-27.386 c-5.488-0.169-10.944-0.058-16.347,0.325c-36.36,2.571-70.446,17.445-97.351,42.761 c-30.906,29.077-48.64,68.451-49.932,110.864c-2.66,87.596,66.398,160.964,153.952,163.631 c5.398,0.165,10.785,0.055,16.137-0.324c23.194-1.641,45.77-8.34,66.086-19.693c0.525-0.293,1.087-0.454,1.65-0.492 c1.48-0.104,2.961,0.633,3.732,2.016c1.06,1.911,0.39,4.318-1.525,5.384c-21.329,11.919-45.032,18.955-69.382,20.678 c-5.618,0.399-11.271,0.513-16.938,0.342c-91.924-2.8-164.421-79.889-161.623-171.78 c1.356-44.528,19.973-85.86,52.419-116.386c28.245-26.577,64.029-42.191,102.2-44.892c5.672-0.401,11.399-0.516,17.158-0.342 c44.53,1.358,85.864,19.973,116.39,52.418C2854.401,780.248,2870.014,816.044,2872.71,854.223z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M3071.535,1564.089c0.186,2.636-1.362,5.185-3.966,6.152c-4.86,1.808-9.841,3.493-14.805,5.007 c-3.225,0.984-6.636-0.832-7.624-4.06c-0.999-3.227,0.835-6.64,4.06-7.624c4.73-1.443,9.478-3.049,14.116-4.773 c3.158-1.176,6.674,0.435,7.854,3.596C3071.376,1562.949,3071.495,1563.521,3071.535,1564.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M3026.178,1576.354c0.218,3.088-1.934,5.901-5.046,6.44c-8.796,1.53-17.772,2.625-26.673,3.253 c-1.874,0.132-3.756,0.244-5.645,0.339c-3.373,0.163-6.123-2.62-6.407-5.799c-0.167-3.37,2.43-6.235,5.796-6.404 c1.806-0.089,3.604-0.194,5.395-0.321c8.491-0.6,17.052-1.644,25.44-3.1c3.326-0.579,6.485,1.647,7.066,4.969 C3026.137,1575.941,3026.164,1576.148,3026.178,1576.354z M2962.834,1579.481c0.021,0.288,0.023,0.584,0.003,0.878 c-0.247,3.366-3.172,5.896-6.537,5.652c-10.795-0.781-21.638-2.24-32.22-4.336c-3.311-0.654-5.453-3.885-4.806-7.177 c0.657-3.311,3.866-5.46,7.177-4.806c10.097,1.999,20.439,3.389,30.735,4.136 C2960.251,1574.051,2962.624,1576.5,2962.834,1579.481z M2900.625,1567.154c0.055,0.773-0.039,1.569-0.294,2.35 c-1.06,3.202-4.52,4.935-7.721,3.876c-10.256-3.402-20.417-7.48-30.187-12.13c-3.051-1.45-4.342-5.084-2.889-8.141 c1.448-3.044,5.094-4.339,8.138-2.892c9.318,4.434,19,8.325,28.783,11.566 C2898.874,1562.587,2900.456,1564.759,2900.625,1567.154z M2843.347,1539.909c0.089,1.262-0.214,2.559-0.94,3.708 c-1.814,2.843-5.594,3.681-8.437,1.867c-9.129-5.823-17.973-12.26-26.293-19.141c-2.597-2.152-2.953-6.005-0.81-8.599 c2.148-2.6,5.997-2.965,8.601-0.814c7.926,6.559,16.366,12.702,25.07,18.253 C2842.235,1536.265,2843.216,1538.044,2843.347,1539.909z M2794.463,1499.503c0.124,1.761-0.514,3.564-1.898,4.873 c-2.449,2.316-6.314,2.206-8.634-0.243c-7.426-7.86-14.44-16.25-20.842-24.941c-2.01-2.716-1.424-6.54,1.293-8.541 s6.543-1.421,8.54,1.293c6.111,8.293,12.799,16.297,19.888,23.794C2793.818,1496.807,2794.367,1498.143,2794.463,1499.503z  M2756.871,1448.463c0.161,2.282-0.976,4.563-3.104,5.759c-2.939,1.651-6.66,0.604-8.315-2.334 c-5.294-9.427-10.05-19.275-14.128-29.266c-1.268-3.136,0.228-6.689,3.349-7.965c3.121-1.275,6.689,0.224,7.962,3.346 c3.89,9.529,8.421,18.914,13.469,27.901C2756.562,1446.717,2756.809,1447.591,2756.871,1448.463z M2732.906,1389.796 c0.202,2.856-1.635,5.548-4.499,6.321c-3.257,0.879-6.61-1.049-7.491-4.305c-2.81-10.404-5.001-21.12-6.519-31.854 c-0.416-3.355,1.86-6.434,5.199-6.902c3.339-0.472,6.428,1.854,6.903,5.193c1.441,10.24,3.532,20.461,6.211,30.381 C2732.815,1389.019,2732.878,1389.409,2732.906,1389.796z M2725.453,1295.254c0.025,0.351,0.02,0.713-0.019,1.078 c-0.936,8.856-1.402,17.918-1.387,26.938c-0.005,1.366,0.005,2.708,0.034,4.046c0.059,3.375-2.621,6.159-5.995,6.221 c-3.38,0.068-6.261-2.635-6.223-5.992c-0.023-1.427-0.04-2.852-0.034-4.285c-0.013-9.423,0.476-18.924,1.459-28.21 c0.355-3.356,3.359-5.786,6.715-5.431C2722.991,1289.933,2725.248,1292.354,2725.453,1295.254z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M3238.509,1300.747c0.235,3.326-2.251,6.234-5.586,6.515c-3.359,0.282-6.316-2.215-6.594-5.577 c-0.846-10.121-2.317-20.275-4.374-30.182c-0.651-3.288,1.434-6.538,4.74-7.223c3.306-0.685,6.536,1.44,7.223,4.74 c2.151,10.39,3.698,21.035,4.584,31.644C3238.505,1300.69,3238.507,1300.72,3238.509,1300.747z M3239.238,1331.987 c0.016,0.221,0.019,0.438,0.011,0.663c-0.386,10.626-1.424,21.337-3.08,31.835c-0.53,3.332-3.652,5.606-6.984,5.079 c-3.338-0.523-5.599-3.67-5.085-6.984c1.583-10.017,2.572-20.238,2.944-30.378c0.121-3.37,2.955-6.003,6.324-5.88 C3236.52,1326.438,3239.021,1328.916,3239.238,1331.987z M3225.826,1239.683c0.191,2.702-1.444,5.298-4.13,6.212 c-3.188,1.084-6.658-0.624-7.744-3.818c-3.274-9.62-7.156-19.12-11.55-28.24c-1.453-3.052-0.185-6.69,2.857-8.151 c3.036-1.464,6.69-0.186,8.154,2.853c4.604,9.56,8.674,19.521,12.101,29.606 C3225.688,1238.656,3225.79,1239.172,3225.826,1239.683z M3229.465,1393.619c0.049,0.693-0.02,1.406-0.221,2.114 c-2.932,10.229-6.526,20.38-10.685,30.166c-1.318,3.106-4.905,4.553-8.011,3.235c-3.095-1.318-4.544-4.905-3.232-8.009 c3.963-9.333,7.388-19.008,10.186-28.761c0.931-3.241,4.314-5.118,7.555-4.187 C3227.59,1388.905,3229.289,1391.132,3229.465,1393.619z M3198.759,1183.502c0.152,2.157-0.848,4.33-2.793,5.576 c-2.843,1.824-6.621,0.997-8.442-1.84c-5.47-8.533-11.52-16.818-17.992-24.628c-2.157-2.601-1.789-6.451,0.81-8.602 c2.599-2.151,6.451-1.789,8.602,0.81c6.78,8.192,13.127,16.877,18.865,25.822 C3198.381,1181.531,3198.69,1182.517,3198.759,1183.502z M3159.004,1135.452c0.117,1.651-0.434,3.341-1.658,4.635 c-2.321,2.448-6.188,2.554-8.635,0.233c-7.376-6.989-15.24-13.592-23.367-19.623c-2.713-2.012-3.277-5.841-1.267-8.546 c2.009-2.71,5.832-3.275,8.539-1.267c8.525,6.323,16.769,13.242,24.498,20.566 C3158.267,1132.544,3158.901,1133.982,3159.004,1135.452z M3108.879,1098.305c0.082,1.16-0.162,2.355-0.785,3.443 c-1.665,2.934-5.396,3.96-8.329,2.293c-8.828-5.025-18.045-9.546-27.391-13.44c-3.106-1.299-4.584-4.876-3.285-7.987 c1.299-3.114,4.873-4.586,7.99-3.288c9.797,4.086,19.466,8.827,28.729,14.093 C3107.651,1094.469,3108.74,1096.336,3108.879,1098.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M3204.949,1451.307c0.083,1.175-0.172,2.386-0.807,3.483c-2.616,4.526-5.38,8.993-8.211,13.284 c-1.859,2.813-5.648,3.592-8.465,1.734c-2.804-1.863-3.586-5.646-1.734-8.465c2.701-4.089,5.336-8.353,7.836-12.671 c1.689-2.921,5.428-3.917,8.345-2.228C3203.736,1447.5,3204.811,1449.353,3204.949,1451.307z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M3125.882,1451.8c0.961-0.904,1.243-2.318,0.701-3.521l-15.448-34.328 c9.719-14.648,17.172-30.952,21.833-48.433l35.921-11.175c1.26-0.391,2.132-1.54,2.173-2.859l1.376-45.132 c0.04-1.319-0.761-2.518-1.994-2.986l-35.174-13.341c-3.588-17.732-10.034-34.459-18.843-49.673l17.51-33.323 c0.613-1.168,0.418-2.597-0.486-3.558l-30.94-32.885c-0.905-0.961-2.319-1.243-3.522-0.701l-34.327,15.448 c-14.648-9.719-30.953-17.172-48.434-21.833l-11.174-35.921c-0.392-1.26-1.54-2.132-2.859-2.173l-45.133-1.375 c-1.319-0.04-2.519,0.761-2.986,1.995l-13.341,35.174c-17.732,3.587-34.459,10.034-49.672,18.843l-33.324-17.51 c-1.167-0.613-2.596-0.418-3.557,0.485l-32.886,30.941c-0.961,0.904-1.242,2.318-0.701,3.521l15.449,34.328 c-9.72,14.648-17.172,30.952-21.833,48.433l-35.922,11.175c-1.259,0.392-2.132,1.539-2.173,2.859l-1.375,45.133 c-0.04,1.319,0.761,2.517,1.994,2.986l35.174,13.341c3.587,17.732,10.034,34.46,18.844,49.673l-17.51,33.322 c-0.614,1.168-0.419,2.598,0.485,3.558l30.94,32.885c0.904,0.961,2.319,1.243,3.522,0.701l34.327-15.448 c14.648,9.719,30.953,17.172,48.434,21.832l11.174,35.922c0.391,1.259,1.54,2.132,2.859,2.171l45.132,1.376 c1.319,0.04,2.518-0.761,2.986-1.995l13.341-35.174c17.732-3.588,34.459-10.034,49.672-18.843l33.323,17.51 c1.168,0.614,2.596,0.419,3.558-0.485L3125.882,1451.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M3019.689,1319.722c0.694,9.829-1.769,19.583-7.169,28.036 c-6.645,10.398-16.943,17.587-28.996,20.24c-24.871,5.481-49.569-10.298-55.057-35.177 c-5.443-24.922,10.306-49.582,35.183-55.061c12.053-2.657,24.419-0.459,34.814,6.186 c10.402,6.644,17.592,16.942,20.244,28.998C3019.202,1315.196,3019.529,1317.463,3019.689,1319.722z M2939.682,1325.254 c0.116,1.64,0.352,3.288,0.714,4.94c4.037,18.299,22.203,29.906,40.503,25.875c8.861-1.953,16.442-7.239,21.325-14.888 c4.889-7.653,6.496-16.745,4.554-25.613l0,0c-1.953-8.865-7.242-16.441-14.889-21.328c-7.653-4.889-16.748-6.505-25.616-4.551 C2949.629,1293.356,2938.515,1308.728,2939.682,1325.254z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M3087.648,1314.044c0.272,3.856,0.35,7.755,0.234,11.698 c-0.236,7.829-1.27,15.643-3.077,23.242c-0.084,0.341-0.167,0.682-0.251,1.023c-0.651,2.635-2.921,4.443-5.491,4.627 c-0.625,0.044-1.268-0.009-1.907-0.167c-3.274-0.81-5.255-4.126-4.457-7.396c1.755-7.079,2.752-14.378,2.971-21.695l0-0.003 c0.013-0.401,0.02-0.805,0.028-1.204c0.362-17.322-3.608-34.077-11.364-49.068c-4.21-8.137-9.544-15.755-15.921-22.657 c-0.052-0.056-0.104-0.112-0.155-0.168c-0.162-0.171-0.317-0.343-0.479-0.511c-18.826-20.006-44.314-31.487-71.772-32.323 c-3.554-0.111-7.083-0.038-10.582,0.209c-23.538,1.665-45.604,11.296-63.026,27.684 c-20.007,18.826-31.482,44.314-32.318,71.769c-0.825,27.439,9.071,53.598,27.89,73.608 c18.825,20.006,44.314,31.487,71.772,32.323c3.494,0.109,6.981,0.036,10.444-0.208c15.018-1.063,29.631-5.399,42.781-12.749 c0.811-0.452,1.678-0.702,2.547-0.76c2.285-0.161,4.572,0.978,5.763,3.112c1.637,2.949,0.596,6.665-2.355,8.314 c-14.715,8.223-31.068,13.076-47.864,14.268c-3.879,0.274-7.778,0.355-11.686,0.236c-30.724-0.937-59.239-13.78-80.301-36.167 c-21.056-22.384-32.162-51.612-31.204-82.346c0.934-30.72,13.774-59.235,36.164-80.295 c19.485-18.337,44.173-29.109,70.508-30.972c3.909-0.276,7.862-0.358,11.835-0.237 C3035.853,1209.045,3083.544,1255.919,3087.648,1314.044z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1268.472,2180.231c0,0,8.874-373.1-162.973-472.958 c-171.846-99.858-498.586-162.29-510.833-698.026c-7.171-313.644-14.931-450.775-20.133-510.569 c-2.029-23.325,18.699-42.152,41.707-37.819c162.753,30.66,691.465,156.858,802.314,517.728 C1549.966,1406.403,1268.472,2180.231,1268.472,2180.231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M742.107,609.917c178.654,159.334,385.234,441.322,495.343,723.311 c14.134,46.473,55.476,145.304,73.43,320.9c16.035,146.45,8.064,301.204-11.38,403.643c-1.229,6.476-7.476,10.73-13.952,9.5 c-11.136-2.113-9.655-14.09-9.554-13.712c22.206-175.02,12.989-392.861-37.894-589.417 c-65.007-241.348-209.997-475.344-359.964-673.805l-15.433-19.542C746.514,621.58,722.054,620.481,732.916,610.08 C735.482,607.623,739.497,607.601,742.107,609.917z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1544.634,2897.567c23.25,11.401-220.109-294.625-296.342-775.261 c-35.922-226.488-36.392-510.259-165.409-619.614c-107.377-91.013-472.768-33.553-592.323-11.717 c-14.939,2.728-19.969,21.6-8.34,31.367c57.334,48.15,179.981,161.725,211.937,276.187 c42.121,150.87,185.557,246.831,313.968,272.802c128.411,25.97,199.843,51.173,262.401,256.531 C1333.084,2533.219,1478.571,2865.174,1544.634,2897.567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M658.708,1554.721c152.535,6.389,316.269,75.97,399.358,206.49l7.843,12.455 c18.113,29.203,120.767,236.806,177.781,408.898c0.709,2.145-0.453,4.461-2.598,5.172c-3.644,1.206-5.469-2.803-5.122-2.449 c-39.723-97.219-96.774-220.477-142.213-312.65c-48.729-100.58-82.829-168.696-193.977-233.941 c-123.71-70.266-241.898-77.499-241.543-77.427c-1.804-0.184-3.117-1.796-2.933-3.599 C655.482,1555.933,656.99,1554.652,658.708,1554.721z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095332816380677486680000008784433401719636381_",
    gradientUnits: "userSpaceOnUse",
    x1: 1922.4326,
    y1: 3026.6055,
    x2: 1790.308,
    y2: -884.3503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095332816380677486680000008784433401719636381_)"
    },
    d: "M992.879,966.172 c0-93.296,75.632-168.928,168.929-168.928h1436.575c79.255,0,144.606,62.109,148.636,141.262l106.04,2082.765 c3.154,61.939-45.605,114.185-107.614,115.313l-1646.496,29.925c-58.266,1.059-106.069-45.883-106.069-104.159V966.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1339.588,3131.1c-0.017,0-0.035,0-0.052,0l-184.233-2.381 c-61.604-0.799-111.721-51.569-111.721-113.175v-278.158c0-2.174,1.761-3.933,3.933-3.933c2.172,0,3.933,1.759,3.933,3.933 v278.158c0,57.323,46.634,104.563,103.957,105.308l184.231,2.382c2.172,0.026,3.91,1.813,3.883,3.983 C1343.49,3129.372,1341.735,3131.1,1339.588,3131.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1047.514,2655.158c-2.172,0-3.933-1.759-3.933-3.933v-45.047c0-2.174,1.761-3.933,3.933-3.933 c2.172,0,3.933,1.76,3.933,3.933v45.047C1051.447,2653.399,1049.686,2655.158,1047.514,2655.158z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1110.571,829.302c-0.176-29.849,26.075-52.952,55.655-48.941 c196.177,26.604,870.78,108.883,1428.533,66.068c25.436-1.952,47.51,17.319,48.864,42.794l111.188,2092.049 c1.525,28.685-20.38,53.215-49.056,54.912c-234.58,13.882-1200.656,67.547-1545.242,31.455 c-20.972-2.197-36.891-19.854-37.016-40.941L1110.571,829.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1133.679,881.727c-0.169-28.725,25.093-50.958,53.559-47.098 c188.79,25.602,837.99,104.783,1374.741,63.58c24.478-1.879,45.721,16.667,47.023,41.183l107.001,2013.272 c1.467,27.605-19.613,51.212-47.208,52.845c-225.747,13.36-1155.445,65.003-1487.055,30.27 c-20.182-2.114-35.502-19.106-35.621-39.399L1133.679,881.727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.58,
      fill: "#FFFFFF"
    },
    d: "M2527.752,1218.967h-663.748c-5.756,0-10.423-4.666-10.423-10.422v-192.051 c0-5.756,4.666-10.422,10.423-10.422h663.748c5.756,0,10.423,4.666,10.423,10.422v192.051 C2538.175,1214.301,2533.508,1218.967,2527.752,1218.967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.58,
      fill: "#FFFFFF"
    },
    d: "M2556.659,1989.927H1262.261c-3.237,0-5.862-2.624-5.862-5.862v-74.58 c0-3.237,2.624-5.862,5.862-5.862h1294.398c3.237,0,5.862,2.624,5.862,5.862v74.58 C2562.521,1987.303,2559.896,1989.927,2556.659,1989.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.58,
      fill: "#FFFFFF"
    },
    d: "M2558.242,2123.082H1260.679c-2.363,0-4.279-1.916-4.279-4.28v-77.745 c0-2.363,1.916-4.279,4.279-4.279h1297.563c2.363,0,4.279,1.916,4.279,4.279v77.745 C2562.521,2121.166,2560.605,2123.082,2558.242,2123.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.58,
      fill: "#FFFFFF"
    },
    d: "M2585.736,2883.382H1262.645c-2.85,0-5.161-2.311-5.161-5.161v-75.982 c0-2.85,2.311-5.161,5.161-5.161h1323.091c2.85,0,5.161,2.311,5.161,5.161v75.982 C2590.897,2881.071,2588.587,2883.382,2585.736,2883.382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "#FFFFFF"
    },
    d: "M2529.759,1813.212H1287.712c-17.293,0-31.312-14.019-31.312-31.312v-465.061 c0-17.293,14.019-31.312,31.312-31.312h1220.987c16.742,0,30.523,13.17,31.28,29.896l21.06,465.061 C2561.846,1798.314,2547.608,1813.212,2529.759,1813.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2530.483,1818.234H1288.437c-20.034,0-36.334-16.3-36.334-36.334v-465.062 c0-20.034,16.3-36.334,36.334-36.334h1220.986c19.472,0,35.419,15.237,36.298,34.691l21.058,465.06 c0.455,10.007-3.106,19.508-10.029,26.75C2549.828,1814.247,2540.502,1818.234,2530.483,1818.234z M1288.437,1290.55 c-14.495,0-26.289,11.792-26.289,26.289V1781.9c0,14.497,11.794,26.289,26.289,26.289h1242.046 c7.249,0,13.998-2.886,19.004-8.125c5.009-5.238,7.586-12.113,7.259-19.354l-21.058-465.06 c-0.641-14.075-12.177-25.101-26.266-25.101H1288.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "#FFFFFF"
    },
    d: "M2549.612,2744.434H1297.2c-21.934,0-39.716-17.781-39.716-39.716v-448.254 c0-21.935,17.781-39.716,39.716-39.716h1235.035c21.336,0,38.86,16.858,39.686,38.177l17.377,448.254 C2590.171,2725.7,2572.15,2744.434,2549.612,2744.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2549.612,2749.456H1297.2c-24.667,0-44.737-20.069-44.737-44.738v-448.255 c0-24.669,20.07-44.738,44.737-44.738h1235.036c24.131,0,43.77,18.89,44.705,43.005l17.376,448.255 c0.474,12.27-3.95,23.901-12.464,32.749C2573.341,2744.583,2561.89,2749.456,2549.612,2749.456z M1297.2,2221.771 c-19.128,0-34.693,15.563-34.693,34.693v448.255c0,19.13,15.564,34.693,34.693,34.693h1252.412 c9.522,0,18.403-3.778,25.004-10.642c6.598-6.862,10.031-15.88,9.662-25.395l-17.376-448.255 c-0.726-18.7-15.953-33.349-34.667-33.349H1297.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1642.607,
    y: 1285.491,
    transform: "matrix(0.9999 -0.0166 0.0166 0.9999 -25.5087 27.582)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10.046,
    height: 527.758
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2123.194,
    y: 1285.431,
    transform: "matrix(0.9996 -0.027 0.027 0.9996 -41.0492 58.0152)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10.042,
    height: 527.877
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1902.152,
    y: 819.152,
    transform: "matrix(0.0035 -1 1 0.0035 434.4874 3367.9998)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10.045,
    height: 1293.678
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1260.34,
    y: 1646.197,
    style: {
      fill: "#FFFFFF"
    },
    width: 1293.664,
    height: 10.045
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1382.672,
    y: 2475.568,
    transform: "matrix(0.0124 -0.9999 0.9999 0.0124 -854.2398 4096.3066)",
    style: {
      fill: "#FFFFFF"
    },
    width: 527.726,
    height: 10.046
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1260.34,
    y: 2339.948,
    style: {
      fill: "#FFFFFF"
    },
    width: 1316.677,
    height: 10.045
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1260.34,
    y: 2461.602,
    style: {
      fill: "#FFFFFF"
    },
    width: 1319.966,
    height: 10.045
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1916.639,
    y: 1941.434,
    transform: "matrix(0.0125 -0.9999 0.9999 0.0125 -707.7621 4494.6807)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10.046,
    height: 1328.456
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095339003194017615740000013050718530296436151_",
    gradientUnits: "userSpaceOnUse",
    x1: 2129.4695,
    y1: 298.8356,
    x2: 1468.696,
    y2: 1168.0675
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095339003194017615740000013050718530296436151_)"
    },
    d: "M1969.192,513.269 c-51.891-36.1-97.011-35.385-128.774-26.012c-28.974,8.549-47.754,36.523-44.998,66.607l13.698,149.51l162.997,14.465 C1972.116,717.839,2070.959,584.067,1969.192,513.269z M1897.512,633.887c-22.446,0-40.643-18.196-40.643-40.643 c0-22.447,18.196-40.643,40.643-40.643c22.447,0,40.643,18.197,40.643,40.643 C1938.155,615.692,1919.959,633.887,1897.512,633.887z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1825.401,640.481c-2.011,0-3.725-1.533-3.912-3.576l-2.182-23.81 c-0.2-2.162,1.394-4.076,3.557-4.275c2.206-0.207,4.079,1.395,4.275,3.561l2.182,23.81c0.2,2.163-1.394,4.075-3.557,4.275 C1825.641,640.477,1825.52,640.481,1825.401,640.481z M1821.126,593.82c-2.01,0-3.725-1.533-3.912-3.576l-1.658-18.075 c-2.627-28.658,15.406-55.342,42.875-63.45c19.454-5.742,39.499-6.564,59.572-2.447c2.128,0.434,3.499,2.516,3.063,4.644 c-0.436,2.124-2.498,3.484-4.642,3.061c-18.804-3.849-37.563-3.085-55.767,2.285c-23.878,7.048-39.553,30.259-37.269,55.191 l1.657,18.076c0.2,2.162-1.394,4.076-3.557,4.275C1821.366,593.817,1821.245,593.82,1821.126,593.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098908306153580243070000016608714603811885190_",
    gradientUnits: "userSpaceOnUse",
    x1: 2201.9514,
    y1: 353.933,
    x2: 1541.177,
    y2: 1223.166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098908306153580243070000016608714603811885190_)"
    },
    d: "M1586.657,799.995v-75.169 c0-25.948,21.506-46.731,47.44-45.843l518.257,17.757c23,0.788,41.626,18.942,43.004,41.915l4.331,72.227L1586.657,799.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1779.903,707.307h-22.287c-2.172,0-3.933-1.759-3.933-3.933c0-2.174,1.761-3.933,3.933-3.933 h22.287c2.172,0,3.933,1.759,3.933,3.933C1783.836,705.547,1782.075,707.307,1779.903,707.307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1614.709,776.391c-2.172,0-3.933-1.759-3.933-3.933v-30.409c0-23.495,19.115-42.608,42.61-42.608 h81.94c2.172,0,3.933,1.759,3.933,3.933c0,2.174-1.761,3.933-3.933,3.933h-81.94c-19.157,0-34.744,15.587-34.744,34.742v30.409 C1618.642,774.632,1616.881,776.391,1614.709,776.391z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157295848277402353150000011382648253173882532_",
    gradientUnits: "userSpaceOnUse",
    x1: 2118.6824,
    y1: 407.1029,
    x2: 1662.4318,
    y2: 1244.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157295848277402353150000011382648253173882532_)"
    },
    d: "M1375.489,818.976 c1.251-26.03,22.719-46.491,48.779-46.492l906.271-0.025c32.587-0.001,60.446,23.45,66.005,55.559l0.767,4.431 c6.088,35.17-20.99,67.338-56.683,67.338h-929.78c-21.361,0-38.384-17.86-37.358-39.197L1375.489,818.976z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1409.786,995.698l-4.228,33.373h-62.045l-23.817,193.184h-40.421l23.66-193.184h-62.205 l4.074-33.373H1409.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1565.527,1222.255h-31.495c-3.551,0-6.37-0.835-8.459-2.506 c-2.089-1.671-3.397-3.917-3.917-6.737l-9.401-47.317h-84.449l-20.995,47.317c-1.151,2.403-3.028,4.543-5.637,6.424 c-2.616,1.88-5.539,2.82-8.776,2.82h-31.962l109.516-226.557h41.52L1565.527,1222.255z M1440.496,1137.022h65.965 l-15.355-77.557c-0.837-3.76-1.674-7.728-2.508-11.907c-0.837-4.177-1.622-8.877-2.351-14.101 c-1.985,5.224-3.943,10.055-5.876,14.492c-1.932,4.442-3.737,8.331-5.405,11.673L1440.496,1137.022z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1648.721,1101.3L1597.8,995.698h36.818c2.717,0,4.676,0.392,5.879,1.175 c1.197,0.783,2.217,2.116,3.054,3.996l34.784,78.181c1.04-2.192,2.295-4.386,3.76-6.58l48.099-71.131 c2.505-3.76,5.585-5.64,9.244-5.64h42.458l-77.086,103.722l56.875,122.835h-36.35c-2.714,0-4.833-0.729-6.343-2.194 c-1.517-1.462-2.691-3.078-3.525-4.856l-39.329-90.718c-0.523,0.837-1.017,1.672-1.484,2.506 c-0.471,0.837-0.968,1.673-1.491,2.508l-58.598,85.703c-1.776,2.611-3.708,4.44-5.797,5.483 c-2.089,1.045-4.388,1.566-6.893,1.566h-40.578L1648.721,1101.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096051262424278454690000015313006078455824271_",
    gradientUnits: "userSpaceOnUse",
    x1: 2532.469,
    y1: 2087.3018,
    x2: 2739.7913,
    y2: 2497.9204
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000096051262424278454690000015313006078455824271_)"
    },
    points: "2692.51,2116.476 2413.698,2139.868 2486.432,2193.452 2672.509,2169.814  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168829620694807893670000000783794940849874365_",
    gradientUnits: "userSpaceOnUse",
    x1: -1923.0884,
    y1: 2026.7207,
    x2: -1852.3096,
    y2: 2026.7207,
    gradientTransform: "matrix(-1 0 0 1 83.0112 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168829620694807893670000000783794940849874365_)"
    },
    d: "M1996.688,2060.348 c-7.867,6.146-34.82-6.685-51.313-15.557c-8.038-4.323-11.931-13.722-9.172-22.422c3.969-12.517,10.583-28.673,18.731-30.71 C1968.454,1988.279,2029.107,2035.021,1996.688,2060.348z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119079449780546594890000009496644376220582841_",
    gradientUnits: "userSpaceOnUse",
    x1: -1577.9738,
    y1: 1712.4849,
    x2: -3630.1973,
    y2: 3209.5461,
    gradientTransform: "matrix(-1 0 0 1 83.0112 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119079449780546594890000009496644376220582841_)"
    },
    d: "M3109.05,2374.542l-1414.876-503.205 l-74.856,207.935l1414.387,517.261c30.041,10.987,63.567-1.198,79.665-28.839c16.534-28.393,32.334-72.756,33.286-139.204 C3147.002,2404.332,3131.814,2382.638,3109.05,2374.542z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140707236512676828400000013684412728951940766_",
    gradientUnits: "userSpaceOnUse",
    x1: 1245.402,
    y1: 1880.3627,
    x2: 1451.8958,
    y2: 1880.3627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140707236512676828400000013684412728951940766_)"
    },
    d: "M1256.454,1817.594l195.442,23.996 c-0.206,26.9-9.015,61.7-38.83,101.624l-163.218-107.67C1241.182,1829.829,1246.151,1816.329,1256.454,1817.594z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142134656374304507660000004323879073559731111_",
    gradientUnits: "userSpaceOnUse",
    x1: -1084.1282,
    y1: -1656.9409,
    x2: -1204.666,
    y2: -545.311,
    gradientTransform: "matrix(-1 0 0 1 83.0112 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142134656374304507660000004323879073559731111_)"
    },
    d: "M1694.174,1871.336 c8.953,130.313-74.856,207.935-74.856,207.935l-206.252-136.057c29.816-39.924,38.624-74.725,38.83-101.624L1694.174,1871.336 z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M3091.499,2438.305c1.714,0,3.318-1.064,3.919-2.774c0.768-2.165-0.369-4.54-2.534-5.304 l-1353.658-478.393c-2.173-0.763-4.545,0.37-5.304,2.535c-0.767,2.164,0.37,4.54,2.535,5.304l1353.658,478.393 C3090.573,2438.228,3091.04,2438.305,3091.499,2438.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M3068.146,2519.883c1.714,0,3.318-1.064,3.919-2.774c0.767-2.164-0.37-4.541-2.535-5.304 l-1353.658-478.397c-2.173-0.763-4.54,0.366-5.304,2.534c-0.768,2.165,0.369,4.54,2.534,5.304l1353.658,478.397 C3067.221,2519.806,3067.688,2519.883,3068.146,2519.883z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014635926995068044460000006527308836439979437_",
    gradientUnits: "userSpaceOnUse",
    x1: -2471.0938,
    y1: 2140.8311,
    x2: -2722.0601,
    y2: 2363.0674,
    gradientTransform: "matrix(-1 0 0 1 83.0112 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014635926995068044460000006527308836439979437_)"
    },
    d: "M2701.306,2202.13l-90.967-7.414 l-39.395,36.315c0,0,9.32,12.884,38.458,5.479c29.139-7.406,69.053-9.222,69.053-9.222s40.226,18.135,40.716-15.796 L2701.306,2202.13z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084511818787328859060000005938017206483908753_",
    gradientUnits: "userSpaceOnUse",
    x1: 2822.814,
    y1: 2954.0034,
    x2: 3058.2751,
    y2: 2954.0034
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084511818787328859060000005938017206483908753_)"
    },
    d: "M2822.814,2736.637 c0,0,125.958,274.529,192.043,388.238c0,0,13.126,71.548,0,94.047l-11.186,4.972l52.205-1.554c0,0,4.638-96.24,1.016-101.615 s-10.865-5.023-10.865-5.023s-22.385-177.346-87.213-215.196l-62.827-216.393L2822.814,2736.637z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178884920003907562060000008312989080806505880_",
    gradientUnits: "userSpaceOnUse",
    x1: 3146.4619,
    y1: 2427.4395,
    x2: 3029.8542,
    y2: 3185.3865
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178884920003907562060000008312989080806505880_)"
    },
    d: "M2981.376,3237.372 c-0.077,1.259,40.765,0.684,62.951,0.279c8.192-0.15,15.176-5.907,16.922-13.913l16.755-88.025 c1.592-8.365-3.72-16.49-12.021-18.388l-9.352-2.138c0,0-13.341,18.301-9.142,35.532c4.2,17.23,7.937,61.864-2.676,67.065 c-10.613,5.201-41.142,6.11-41.142,6.11S2982.074,3226.036,2981.376,3237.372z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175309713477459922260000000965029643433585826_",
    gradientUnits: "userSpaceOnUse",
    x1: 2899.7322,
    y1: 2389.4834,
    x2: 2783.1243,
    y2: 3147.4316
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175309713477459922260000000965029643433585826_)"
    },
    d: "M2703.427,3238.969 c-4.131,2.354-2.427,8.66,2.327,8.613c37.128-0.373,120.324-1.548,127.718-4.622c9.544-3.969-3.478-38.266-17.184-49.874 l-75.676,24.698L2703.427,3238.969z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159466018521404113410000018111034752739908025_",
    gradientUnits: "userSpaceOnUse",
    x1: 2679.9373,
    y1: 2971.5115,
    x2: 2816.2881,
    y2: 2971.5115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159466018521404113410000018111034752739908025_)"
    },
    d: "M2679.937,2719.129 c0,0,81.397,393.77,104.423,470.582l-54.471,34.183c0,0,27.297-4.643,47.539-6.11c20.242-1.467,38.861-24.698,38.861-24.698 l-6.526-10.408c0,0-20.412-391.626-15.443-436.096L2679.937,2719.129z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178172607047837009290000003644321383139334046_",
    gradientUnits: "userSpaceOnUse",
    x1: -2326.1626,
    y1: 4535.5293,
    x2: -2013.7719,
    y2: 4535.5293,
    gradientTransform: "matrix(0.1696 -0.9855 0.9855 0.1696 -1675.4594 -682.3968)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178172607047837009290000003644321383139334046_)"
    },
    d: "M2281.432,2266.034 c12.093-0.072,220.23-3.624,351.211-162.329c1.066-1.292,3.045-1.283,4.076,0.037l52.83,67.639 c0.69,0.883,0.754,2.098,0.141,3.036c-11.59,17.745-124.652,178.708-382.412,128.891c-8.507-1.644-17.337-0.044-24.765,4.418 l-45.088,27.09c-18.682,11.224-41.653,12.667-61.593,3.87l-13.365-5.897c-7.561-3.336-9.814-12.989-4.512-19.328h0 c9.217-11.019,21.665-18.862,35.583-22.42l40.984-10.476c11.026-2.818-5.421-13.963-16.042-20.271 c-2.254-1.338-1.335-4.814,1.285-4.898c21.791-0.702,42.263,2.062,60.614,10.41 C2280.716,2265.959,2281.066,2266.037,2281.432,2266.034z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183209656040491601170000018001860492929686159_",
    gradientUnits: "userSpaceOnUse",
    x1: 3697.0681,
    y1: 1135.5438,
    x2: 3181.4324,
    y2: 1724.8425
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183209656040491601170000018001860492929686159_)"
    },
    d: "M2646.653,2094.815 c74.168-25.457,160.951,17.364,202.885,35.322l-40.514,228.628l3.224,37.29l-132.094-0.592c0,0-35.885-69.178-68.407-109.882 c-22.277-27.881-13.44-73.016-13.44-73.016l36.407-111.389C2636.385,2096.215,2641.703,2096.515,2646.653,2094.815z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020377841809090990050000003294912730303967670_",
    gradientUnits: "userSpaceOnUse",
    x1: 2559.5522,
    y1: 2355.5352,
    x2: 2996.8301,
    y2: 2848.687
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020377841809090990050000003294912730303967670_)"
    },
    d: "M2669.57,2375.95l2.598,22.591 c0,0-37.329,111.793,18.666,372.9c0,0,121.271,34.356,220.943-47.854c0,0-28.116-246.445-35.796-257.925 c-38.251-57.178-63.733-69.608-63.733-69.608l-1.149-24.681C2811.099,2371.374,2704.493,2390.648,2669.57,2375.95z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112598067405402151160000017984850954809537685_",
    gradientUnits: "userSpaceOnUse",
    x1: 2699.0627,
    y1: 2077.9712,
    x2: 2782.5022,
    y2: 2077.9712
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112598067405402151160000017984850954809537685_)"
    },
    d: "M2699.069,2111.644 c-0.464-0.612,27.577-84.659,27.577-84.659l40.166,3.644l15.691,95.347C2782.502,2125.975,2719.554,2138.681,2699.069,2111.644z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011734842522931458060000014009104053900970630_",
    gradientUnits: "userSpaceOnUse",
    x1: 2735.2969,
    y1: 2210.8591,
    x2: 3342.6108,
    y2: 2252.1565,
    gradientTransform: "matrix(0.9981 -0.0618 0.0618 0.9981 -42.7447 -66.906)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011734842522931458060000014009104053900970630_)"
    },
    d: "M2744.97,1899.757 c-2.57,1.83-83.437,41.27-60.267,126.325c1.369,5.026,5.034,9.131,9.914,10.955c12.515,4.677,39.31,12.354,70.472,7.224 c43.203-7.112,66.991-84.744,64.411-106.746S2770.441,1881.618,2744.97,1899.757z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134952749229660646130000014589277509249936538_",
    gradientUnits: "userSpaceOnUse",
    x1: 2827.0781,
    y1: 2180.9683,
    x2: 2613.3035,
    y2: 2608.5166,
    gradientTransform: "matrix(0.9981 -0.0618 0.0618 0.9981 -42.7447 -66.906)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134952749229660646130000014589277509249936538_)"
    },
    d: "M2760.539,1871.898 c-2.165,0.421-46.954,19.202-22.198,50.967c24.757,31.766,34.483,50.765,24.648,65.997c-8.96,13.877-31.099,7.656-27.498,35.149 c0.721,5.503-1.337,11.017-5.732,14.406c-19.564,15.088-66.75,60.722-13.629,118.341c4.317,4.683,5.566,11.44,2.814,17.185 c-12.851,26.827-38.512,104.674,74.042,140c111.221,34.908,146.046-38.539,155.247-67.604 c1.99-6.286,7.802-10.419,14.395-10.516c11.972-0.176,28.766-3.21,27-19.115c-1.073-9.661-7.657-17.97-15.233-24.489 c-7.499-6.452-6.849-18.604,1.433-24.014c6.257-4.086,11.64-10.194,13.506-19.32c5.072-24.805-12.592-96.939-83.281-104.97 c-5.896-0.67-12.343-5.76-13.555-11.569c-0.018-0.086-0.037-0.172-0.057-0.259c-1.289-5.611,0.27-11.527,4.693-15.213 c10.657-8.882,23.954-26.259,10.686-51.982c-11.768-22.814-32.04-29.5-46.891-31.111c-8.719-0.946-14.897-8.754-13.609-17.429 C2850.832,1892.714,2844.196,1855.614,2760.539,1871.898z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127019724856354734020000000424224723129685951_",
    gradientUnits: "userSpaceOnUse",
    x1: 1033.9469,
    y1: 220.0044,
    x2: 911.4363,
    y2: 1349.8264
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127019724856354734020000000424224723129685951_)"
    },
    d: "M1066.303,2693.637H476.347 c-3.092,0-5.599-2.507-5.599-5.599v-92.139c0-3.093,2.507-5.599,5.599-5.599h589.956c3.093,0,5.599,2.507,5.599,5.599v92.139 C1071.902,2691.13,1069.395,2693.637,1066.303,2693.637z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142861247866375516830000011047370462889151109_",
    gradientUnits: "userSpaceOnUse",
    x1: 1022.0108,
    y1: 220.5023,
    x2: 899.5003,
    y2: 1350.3243
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142861247866375516830000011047370462889151109_)"
    },
    d: "M1066.303,2584.058H476.347 c-3.092,0-5.599-2.507-5.599-5.599v-92.139c0-3.092,2.507-5.599,5.599-5.599h589.956c3.093,0,5.599,2.507,5.599,5.599v92.139 C1071.902,2581.551,1069.395,2584.058,1066.303,2584.058z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156582757336508110300000013837560131628455064_",
    gradientUnits: "userSpaceOnUse",
    x1: 1046.084,
    y1: 219.4881,
    x2: 923.5734,
    y2: 1349.3108
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156582757336508110300000013837560131628455064_)"
    },
    d: "M1066.303,2805.052H476.347 c-3.092,0-5.599-2.507-5.599-5.599v-92.139c0-3.093,2.507-5.599,5.599-5.599h589.956c3.093,0,5.599,2.507,5.599,5.599v92.139 C1071.902,2802.546,1069.395,2805.052,1066.303,2805.052z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139289204726087159960000015558237436295908482_",
    gradientUnits: "userSpaceOnUse",
    x1: 1058.2191,
    y1: 218.9898,
    x2: 935.7086,
    y2: 1348.8125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139289204726087159960000015558237436295908482_)"
    },
    d: "M1066.303,2916.468H476.347 c-3.092,0-5.599-2.507-5.599-5.599v-92.139c0-3.092,2.507-5.599,5.599-5.599h589.956c3.093,0,5.599,2.507,5.599,5.599v92.139 C1071.902,2913.961,1069.395,2916.468,1066.303,2916.468z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037682741451858691870000014333816698121369221_",
    gradientUnits: "userSpaceOnUse",
    x1: 1070.3555,
    y1: 218.4819,
    x2: 947.845,
    y2: 1348.3037
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037682741451858691870000014333816698121369221_)"
    },
    d: "M1066.303,3027.884H476.347 c-3.092,0-5.599-2.507-5.599-5.599v-92.14c0-3.092,2.507-5.599,5.599-5.599h589.956c3.093,0,5.599,2.507,5.599,5.599v92.14 C1071.902,3025.377,1069.395,3027.884,1066.303,3027.884z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019657571594271226190000015485069293265730698_",
    gradientUnits: "userSpaceOnUse",
    x1: 1082.1283,
    y1: 217.9767,
    x2: 959.6178,
    y2: 1347.7983
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019657571594271226190000015485069293265730698_)"
    },
    d: "M1066.303,3135.951H476.347 c-3.092,0-5.599-2.507-5.599-5.599v-92.14c0-3.093,2.507-5.6,5.599-5.6h589.956c3.093,0,5.599,2.507,5.599,5.6v92.139 C1071.902,3133.444,1069.395,3135.951,1066.303,3135.951z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134960163817750157590000003999855915598475674_",
    gradientUnits: "userSpaceOnUse",
    x1: 1093.8998,
    y1: 217.4842,
    x2: 971.3893,
    y2: 1347.3062
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134960163817750157590000003999855915598475674_)"
    },
    d: "M1066.303,3244.018H476.347 c-3.092,0-5.599-2.507-5.599-5.599v-92.139c0-3.092,2.507-5.599,5.599-5.599h589.956c3.093,0,5.599,2.507,5.599,5.599v92.139 C1071.902,3241.511,1069.395,3244.018,1066.303,3244.018z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008870169081189795050000012428319262811055750_",
    gradientUnits: "userSpaceOnUse",
    x1: 1675.0874,
    y1: 287.2189,
    x2: 1552.5769,
    y2: 1417.0415
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008870169081189795050000012428319262811055750_)"
    },
    d: "M1692.166,2901.75h-589.956 c-3.092,0-5.599-2.507-5.599-5.599v-92.139c0-3.093,2.507-5.6,5.599-5.6h589.956c3.093,0,5.599,2.507,5.599,5.6v92.139 C1697.765,2899.243,1695.258,2901.75,1692.166,2901.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145047552886430339930000002996239801344204197_",
    gradientUnits: "userSpaceOnUse",
    x1: 1687.2236,
    y1: 286.7113,
    x2: 1564.7131,
    y2: 1416.5331
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145047552886430339930000002996239801344204197_)"
    },
    d: "M1692.165,3013.166h-589.956 c-3.092,0-5.599-2.507-5.599-5.599v-92.14c0-3.093,2.507-5.6,5.599-5.6h589.956c3.093,0,5.599,2.507,5.599,5.6v92.139 C1697.765,3010.659,1695.258,3013.166,1692.165,3013.166z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160159884707225511790000001452733861940380557_",
    gradientUnits: "userSpaceOnUse",
    x1: 1698.9948,
    y1: 286.2226,
    x2: 1576.4843,
    y2: 1416.0443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160159884707225511790000001452733861940380557_)"
    },
    d: "M1692.165,3121.233h-589.956 c-3.092,0-5.599-2.507-5.599-5.599v-92.14c0-3.093,2.507-5.599,5.599-5.599h589.956c3.093,0,5.599,2.507,5.599,5.599v92.14 C1697.765,3118.726,1695.258,3121.233,1692.165,3121.233z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018205611585274925850000015207115416597635238_",
    gradientUnits: "userSpaceOnUse",
    x1: 1710.7665,
    y1: 285.728,
    x2: 1588.2559,
    y2: 1415.5507
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018205611585274925850000015207115416597635238_)"
    },
    d: "M1692.165,3229.3h-589.956 c-3.092,0-5.599-2.507-5.599-5.599v-92.139c0-3.093,2.507-5.599,5.599-5.599h589.956c3.093,0,5.599,2.507,5.599,5.599v92.139 C1697.765,3226.793,1695.258,3229.3,1692.165,3229.3z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxes);
export default __webpack_public_path__ + "static/media/taxes.730298589d5b72f49a8a9882701ec0f6.svg";
export { ForwardRef as ReactComponent };